var exports = {
  "Qs": "GameActivitySettingsTab.module__content___Q0JUNz",
  "h_": "GameActivitySettingsTab.module__description___Q0JUNz",
  "o1": "GameActivitySettingsTab.module__actions___Q0JUNz",
  "aO": "GameActivitySettingsTab.module__rules___Q0JUNz",
  "Hu": "GameActivitySettingsTab.module__rule___Q0JUNz",
};

module.exports = exports;
